module.exports = __webpack_public_path__ + "static/IMAGE_~4-ab72eb743539214fbbc215883bccaec1.png";